import { useState } from "react";
import Button from "../Button/Button";
import Input from "../Input/Input";
import Chip from "../Chip/Chip";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

export default function Interests({ currentList, user, setCurrentList }) {
    const member = currentList?.memberInfo?.find((m) => m.uid === user.uid);
    const [inputValue, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);

    if (!member) return null;

    const updateMemberInterests = async (updatedInterests) => {
        setLoading(true);
        try {
            const listRef = doc(db, "lists", currentList.id);
            const updatedMemberInfo = currentList.memberInfo.map((m) =>
                m.uid === user.uid ? { ...m, interests: updatedInterests } : m
            );
            await updateDoc(listRef, { memberInfo: updatedMemberInfo });
            setCurrentList((prev) => ({ ...prev, memberInfo: updatedMemberInfo }));
        } catch (err) {
            console.error("Error updating interests:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddInterest = async (e) => {
        e?.preventDefault?.(); // prevent form reload
        const trimmed = inputValue.trim();
        if (!trimmed || !member) return;

        const updatedInterests = [...(member.interests || []), trimmed];
        await updateMemberInterests(updatedInterests);
        setInputValue("");
    };

    const handleRemoveInterest = async (interestToRemove) => {
        if (!member) return;

        const updatedInterests = [...(member.interests || [])];
        const index = updatedInterests.findIndex(
            (i) => i.toLowerCase() === interestToRemove.toLowerCase()
        );

        if (index > -1) {
            updatedInterests.splice(index, 1);
            await updateMemberInterests(updatedInterests);
        }
    };

    return (
        <div className="mt-4 mb-6">
            <h3 className="text-md font-semibold mb-2">Your Interests</h3>

            {/* Input + Add Button */}
            <form
                className="flex gap-2 mb-3"
                onSubmit={handleAddInterest}
            >
                <Input
                    name="interest"
                    className="w-full"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    disabled={loading}
                    placeholder="Add an interest"
                />
                <Button
                    type="submit"
                    variant="primary"
                    disabled={!inputValue.trim() || loading}
                >
                    Add
                </Button>
            </form>

            {/* Interest Chips */}
            <div className="flex flex-wrap gap-2">
                {(member.interests || []).map((interest, index) => (
                    <Chip
                        key={index}
                        label={interest}
                        onRemove={handleRemoveInterest}
                        showRemove={true}
                    />
                ))}
            </div>
        </div>
    );
}
